const CACHE_KEY = 'llra_user_location';
const CACHE_TTL_MS = 30 * 60 * 1000;
const GEO_TIMEOUT_MS = 5000;

export const UK_FALLBACK_CENTER = { lat: 51.5074, lng: -0.1278 };

export const SEARCH_DEBOUNCE_MS = 500;

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.lat || !parsed?.lng || !parsed?.ts) return null;
    if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
    return { lat: parsed.lat, lng: parsed.lng, fromUser: parsed.fromUser === true };
  } catch {
    return null;
  }
}

function writeCache(location, fromUser) {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ lat: location.lat, lng: location.lng, fromUser, ts: Date.now() }),
    );
  } catch {
    // ignore quota errors
  }
}

function requestBrowserLocation() {
  return new Promise((resolve) => {
    if (!navigator?.geolocation) {
      resolve(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { enableHighAccuracy: false, timeout: GEO_TIMEOUT_MS, maximumAge: CACHE_TTL_MS },
    );
  });
}

/**
 * Returns user geolocation when permitted, otherwise UK-wide fallback.
 * @returns {Promise<{ lat: number, lng: number, fromUser: boolean }>}
 */
export async function getUserLocation() {
  const cached = readCache();
  if (cached) return cached;

  const browserLocation = await requestBrowserLocation();
  if (browserLocation) {
    const result = { ...browserLocation, fromUser: true };
    writeCache(result, true);
    return result;
  }

  const fallback = { ...UK_FALLBACK_CENTER, fromUser: false };
  writeCache(fallback, false);
  return fallback;
}

export function getMapZoomForLocation(location) {
  return location?.fromUser ? 11 : 6.2;
}
